import React from "react";
import PropTypes from 'prop-types';
import "./ScreenHeader.scss";

const ScreenHeader = ({ heading, subHeading }) => {
    return (
        <span className="screen-header-container">
            {
                heading &&
                <h2 className="heading">{heading}</h2>
            }
            {
                subHeading &&
                <h4 className="sub-heading">{subHeading}</h4>
            }
        </span>
    );
}

export default ScreenHeader;

ScreenHeader.propTypes = {
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired
}